import { render, staticRenderFns } from "./contact-banking-accounts.vue?vue&type=template&id=55936564&lang=html&"
import script from "./contact-banking-accounts.vue?vue&type=script&lang=js&"
export * from "./contact-banking-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports